import { Controller } from "@hotwired/stimulus";

// Scrolls to the enrollment form and focuses its first text input.
export default class extends Controller {
  scroll() {
    const form = document.getElementById("enrollment-form");
    if (!form) return;

    form.scrollIntoView({ behavior: "smooth", block: "start" });
    form.querySelector('input[type="text"]')?.focus();
  }
}
